// how-to-start/utils/slide-index.ts
//
// WHERE A SLIDE GOES IN A DECK THAT IS STILL BEING WRITTEN.
//
// Slides are generated many at a time and come back in any order, so slide 7
// routinely arrives before slide 3. Each one still has to land in the slot its
// outline gave it, with the gaps closing up as the stragglers arrive.
//
// This was once done by anchoring -- "insert after the nearest earlier slide"
// -- which reads well until a slide belongs before EVERYTHING already placed.
// There is no slide to sit after then, and the empty anchor the editor was
// given fell back to the currently selected slide, so the cover was inserted
// halfway down the deck. Counting is exact where anchoring was not: a deck
// being filled holds exactly the placed slides in position order, so the slot
// for a position is simply how many placed positions come before it.

/**
 * The index `position` should be inserted at, given what is already placed.
 *
 * `placed` holds the plan positions currently in the deck. Returns 0 when the
 * slide belongs at the very front.
 */
export const slideIndexFor = (
  placed: ReadonlySet<number> | ReadonlyMap<number, unknown>,
  position: number,
): number => {
  let before = 0;
  placed.forEach((_value: unknown, at: number) => {
    if (at < position) before += 1;
  });
  return before;
};
